/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertUploadJobStatus } from './ControlZeroDayAlertUploadJobStatus';
import {
    ControlZeroDayAlertUploadJobStatusFromJSON,
    ControlZeroDayAlertUploadJobStatusFromJSONTyped,
    ControlZeroDayAlertUploadJobStatusToJSON,
} from './ControlZeroDayAlertUploadJobStatus';

/**
 * 
 * @export
 * @interface ControlCreateAssociateClientsJobResponse
 */
export interface ControlCreateAssociateClientsJobResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlCreateAssociateClientsJobResponse
     */
    job_id: string;
    /**
     * 
     * @type {ControlZeroDayAlertUploadJobStatus}
     * @memberof ControlCreateAssociateClientsJobResponse
     */
    status: ControlZeroDayAlertUploadJobStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateAssociateClientsJobResponse
     */
    created_at: string;
}

/**
 * Check if a given object implements the ControlCreateAssociateClientsJobResponse interface.
 */
export function instanceOfControlCreateAssociateClientsJobResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "job_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function ControlCreateAssociateClientsJobResponseFromJSON(json: any): ControlCreateAssociateClientsJobResponse {
    return ControlCreateAssociateClientsJobResponseFromJSONTyped(json, false);
}

export function ControlCreateAssociateClientsJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCreateAssociateClientsJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'job_id': json['job_id'],
        'status': ControlZeroDayAlertUploadJobStatusFromJSON(json['status']),
        'created_at': json['created_at'],
    };
}

export function ControlCreateAssociateClientsJobResponseToJSON(value?: ControlCreateAssociateClientsJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.job_id,
        'status': ControlZeroDayAlertUploadJobStatusToJSON(value.status),
        'created_at': value.created_at,
    };
}

